import { render, staticRenderFns } from "./SpotTheNotImage.vue?vue&type=template&id=6d8724fc&scoped=true"
import script from "./SpotTheNotImage.vue?vue&type=script&lang=js"
export * from "./SpotTheNotImage.vue?vue&type=script&lang=js"
import style0 from "./SpotTheNotImage.vue?vue&type=style&index=0&id=6d8724fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8724fc",
  null
  
)

export default component.exports